import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Autocomplete,
  FormControl,
  IconButton,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ModalBox } from "../../../styles/ModalStyles";
import { getClienteHabilitado } from "../../http/actions/ClientesAction";
import CloseIcon from "@mui/icons-material/Close";

const NuevoEnlaceCongresoModal = ({ open, onClose, onSubmit }) => {
  const [correlativo, setCorrelativo] = useState("");
  const [url, setUrl] = useState("");
  const [titulo, setTitulo] = useState("");
  const [etapa, setEtapa] = useState("");
  const [subEtapa, setSubEtapa] = useState("");
  const [boletin, setBoletin] = useState("");
  const [fecha, setFecha] = useState(null);
  const [xmlSenado, setXmlSenado] = useState("");
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  useEffect(() => {
    fetchClientes();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      url_camara: url,
      titulo,
      etapa,
      subEtapa,
      boletin,
      fecha: fecha ? fecha.toISOString() : null,
      correlativo,
      xml_senado: xmlSenado,
      clienteId: clienteSeleccionado ? clienteSeleccionado.id : null,
    });
    // Resetear los campos
    setCorrelativo("");
    setUrl("");
    setTitulo("");
    setEtapa("");
    setSubEtapa("");
    setBoletin("");
    setFecha(null);
    setXmlSenado("");
    setClienteSeleccionado(null);
  };

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6">Nuevo enlace de congreso</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Correlativo"
            value={correlativo}
            onChange={(e) => setCorrelativo(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="URL Cámara"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Título"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Etapa"
            value={etapa}
            onChange={(e) => setEtapa(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Sub Etapa"
            value={subEtapa}
            onChange={(e) => setSubEtapa(e.target.value)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Boletín"
            value={boletin}
            onChange={(e) => setBoletin(e.target.value)}
            margin="normal"
          />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              sx={{ mt: 2 , width: "100%"}}
              label="Fecha"
              format="dd/MM/yyyy"
              value={fecha}
              onChange={(newValue) => setFecha(newValue)}
              renderInput={(params) => (
                <TextField {...params} fullWidth margin="normal" />
              )}
            />
          </LocalizationProvider>
          <TextField
          sx={{ mt: 3 }}
            fullWidth
            label="XML Senado"
            value={xmlSenado}
            onChange={(e) => setXmlSenado(e.target.value)}
            margin="normal"
          />
          <FormControl fullWidth sx={{ mt: 2 }}>
            <Autocomplete
              noOptionsText="No hay opciones disponibles"
              options={clientes}
              getOptionLabel={(option) => option.nombre || ""}
              renderInput={(params) => (
                <TextField {...params} label="Cliente" />
              )}
              value={clienteSeleccionado}
              onChange={(event, newValue) => {
                setClienteSeleccionado(newValue);
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </FormControl>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mr: 1 }}
            >
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default NuevoEnlaceCongresoModal;
